<template>
  <!-- newsletter widget -->
  <div class="aside-widget">
    <div class="section-title">
      <h2 class="title">Newsletter</h2>
    </div>
    <div class="newsletter-widget">
      <div style="position:relative;z-index:2;">
        <p>Mantenha-se informado sobre nossas novidades.</p>
        <input
          class="input"
          name="newsletter"
          v-model="newsletter.email"
          placeholder="Informe o seu e-mail"
        />

        <transition enter-active-class="animated fadeIn">
          <p style="color:#8bc725;" v-show="messageSent">E-mail cadastrado. Obrigado pelo interesse!</p>
        </transition>

        <transition enter-active-class="animated fadeIn">
          <p style="color:#f00;" v-show="warningMessage != ''">{{ warningMessage }}</p>
        </transition>
        <button @click="sendNewsletter" class="primary-button">
          <div v-show="!newsletterLoading">INSCREVA-SE</div>
          <div v-show="newsletterLoading" class="loading-spinner"></div>
        </button>
      </div>
    </div>
  </div>
  <!-- /newsletter widget -->
</template>
<script>
import validators from "../util/validators";
import http from "@/http";

export default {
  name: "Newsletter",
  data() {
    return {
      newsletterLoading: false,
      newsletter: {
        email: ""
      },
      warningMessage: "",
      messageSent: false
    };
  },
  methods: {
    sendNewsletter() {
      if (this.newsletter.email == "") {
        this.warningMessage = "Por favor, informe o seu e-mail.";
        return;
      }

      if (!validators.validateEmail(this.newsletter.email)) {
        this.warningMessage = "Por favor, informe um e-mail correto.";
        return;
      }

      this.warningMessage = "";
      this.newsletterLoading = true;

      http
        .post("newsletter", this.newsletter)
        .then(response => {
          this.messageSent = true;
          this.newsletter.email = "";
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.newsletterLoading = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Newsletter.vue